import { EmployeeViewType } from "../enums/employeeViewType";
import { getWhoIsWorking } from "../redux/features/whoIsIn";

/**
 * Map of viewTypes to corresponding thunks
 * 
 * @deprecated
 */
export const handlerMap: Record<EmployeeViewType, any> = {
    WHO_IS_WORKING: getWhoIsWorking,
    // Add more handlers as needed
};